import React from "react";
import PhoneNumberHeader from "./PhoneNumberHeader";
import AssignDepartmentList from "./AssignDepartmentList";
import CustomTypography from "../../../commonComponents/CustomTypography";
import CustomSkeleton from "../../../commonComponents/CustomSkeleton";
import { STATIC_DEPARTMENTS, getItemIdentifier } from "./gotoHelpers";
import useLang from "../../../../hooks/useLang";

const AssignDepartmentDrawer = ({
  phoneData,
  extensionData,
  userData,
  deviceData,
  onDepartmentSelect,
}) => {
  const [gotoLang] = useLang("GoTo");
  // const [searchText, setSearchText] = useState("");

  // Fetch departments using the hook - COMMENTED OUT (using static departments)
  // const { departments, fetching } = useDepartment({ locationId });

  // Use static departments instead
  const departments = STATIC_DEPARTMENTS;
  const fetching = false;

  // Get current department data from all 4 types: phone, extension, user, device
  // departmentLevel is a string (e.g., "FINANCE", "MARKETING"), not an object
  const currentDepartmentLevel =
    phoneData?.departmentLevel ||
    extensionData?.departmentLevel ||
    userData?.departmentLevel ||
    deviceData?.department;

  // Find the matching department object from STATIC_DEPARTMENTS to get the name
  const currentDepartment = departments.find(dept => dept.id === currentDepartmentLevel);
  const currentDepartmentId = currentDepartmentLevel;

  // Get the item identifier (number, name, etc.) for the header using helper function
  const itemIdentifier = getItemIdentifier(phoneData, extensionData, userData, deviceData);

  // Filter departments based on search text - COMMENTED OUT (no search for static list)
  // const filteredDepartments = useMemo(() => {
  //   if (!searchText) return departments;
  //   return departments.filter(dept => dept.name?.toLowerCase().includes(searchText.toLowerCase()));
  // }, [departments, searchText]);

  const filteredDepartments = departments;

  return (
    <div>
      {/* Header showing current assignment */}
      <div className="mb-6">
        <PhoneNumberHeader
          phoneNumber={itemIdentifier}
          assignedTo={currentDepartment?.name || null}
          assignedToRole={null}
          label={gotoLang.currentlyAssignedTo}
        />
      </div>

      <div className="my-6">
        <CustomTypography variant="text" strong>
          {gotoLang.selectDepartmentToAssign}
        </CustomTypography>

        {/* Search functionality - COMMENTED OUT (no search for static list) */}
        {/* <DebounceInput
          className="mt-5"
          placeholder="Search department by name"
          value={searchText}
          onChange={setSearchText}
          suffix={<SearchOutlined className="icon-color" />}
        /> */}
      </div>

      {/* Departments List - Scrollable with fixed height */}
      <div className="overflow-y-auto pr-2" style={{ height: "calc(100vh - 348px)" }}>
        {fetching ? (
          <CustomSkeleton
            skeletonCount={5}
            skeletonWidth="34rem"
            skeletonHeight="3rem"
            skeletonMarginBottom="15px"
          />
        ) : (
          <AssignDepartmentList
            departments={filteredDepartments}
            onDepartmentSelect={onDepartmentSelect}
            initialSelectedDepartmentId={currentDepartmentId}
          />
        )}
      </div>
    </div>
  );
};

export default AssignDepartmentDrawer;
